import React, {createContext, PropsWithChildren, useContext, useState} from 'react';

interface AccordionIdentificationInterface {
    label: string;
}

interface SideNavigationAccordionContextInterface {
    openAccordion: AccordionIdentificationInterface;
    setOpenAccordion: React.Dispatch<React.SetStateAction<AccordionIdentificationInterface>>;
    nextAccordion: AccordionIdentificationInterface;
    setNextAccordion: React.Dispatch<React.SetStateAction<AccordionIdentificationInterface>>;
}

export const SideNavigationAccordionContext = createContext<SideNavigationAccordionContextInterface | undefined>(undefined);

export const SideNavigationAccordionProvider = ({children}: PropsWithChildren) => {
    const [openAccordion, setOpenAccordion] = useState<AccordionIdentificationInterface>({label: ''});
    const [nextAccordion, setNextAccordion] = useState<AccordionIdentificationInterface>({label: ''});

    return (
        <SideNavigationAccordionContext.Provider value={{openAccordion, setOpenAccordion, nextAccordion, setNextAccordion}}>
            {children}
        </SideNavigationAccordionContext.Provider>
    )
}

export const useAccordionContext = () => {
    const context =  useContext(SideNavigationAccordionContext);;
    if (!context) {
        throw new Error('useAccordionContext must be used within a SideNavigationAccordionProvider');
    }
    return context;
};